'use strict';

require('../../style/index.css');

require('./index.css');

require('../../button/style/css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/modal/style/css.js
// module id = ./node_modules/antd/lib/modal/style/css.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons